import { type FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Form, Tabs, Tab } from 'react-bootstrap';
import Papa from 'papaparse';

import ModalWindow from '@editor2/components/ModalWindow';
import { loadDataTab } from './styles';
import { showToast } from '@editor2/reducers/toastSlice';
import { ToastSeverity } from '@editor2/types/toastSeverity';

interface Props {
	isShown: boolean;
	onHide: () => void;
	onSubmit: (payload: any) => void;
}

const LoadDataModal: FC<Props> = (props) => {
	const { isShown, onHide, onSubmit } = props;

	const [key, setKey] = useState('file');
	const [file, setFile] = useState(null);
	const [textData, setTextData] = useState('');

	const dispatch = useDispatch();

	const onSubmitClick = () => {
		switch (key) {
			case 'file':
				Papa.parse(file, {
					skipEmptyLines: true,
					complete: (result) => {
						onSubmit(result.data);
					}
				});
				break;
			case 'string':
				const stringData = Papa.parse(textData);
				onSubmit(stringData.data);
				break;
			default:
				break;
		}
		onHide();
	};

	const handleFileChange = (e) => {
		const file = e.target.files[0];

		if (file.name.split('.').pop() !== 'csv') {
			dispatch(
				showToast({
					severity: ToastSeverity.Error,
					message: 'Expected CSV file extention.'
				})
			);
		} else {
			setFile(file);
		}
	};

	const checkLoadButtonEnabled = () => {
		switch (key) {
			case 'file':
				return file && file.name.split('.').pop() === 'csv';
			case 'string':
				return !!textData;
			default:
				break;
		}
	};

	const title = <div>Load data</div>;

	const footer = (
		<>
			<Button variant="success" disabled={!checkLoadButtonEnabled()} onClick={onSubmitClick}>
				Load
			</Button>
		</>
	);

	return (
		<ModalWindow isShown={isShown} onHide={onHide} title={title} footer={footer}>
			<Tabs activeKey={key} onSelect={(k) => setKey(k)}>
				<Tab eventKey="file" title="File" className={loadDataTab}>
					<Form.Group>
						<Form.Label>
							Load data from <strong>CSV</strong> file
						</Form.Label>
						<Form.Control type="file" onChange={(e) => handleFileChange(e)} />
					</Form.Group>
				</Tab>

				<Tab eventKey="string" title="String" className={loadDataTab}>
					<Form.Group>
						<Form.Label>
							Paste <strong>CSV</strong> data in the field below
						</Form.Label>
						<Form.Control
							as="textarea"
							rows={7}
							defaultValue={textData}
							onChange={(e) => setTextData(e.target.value)}
						/>
					</Form.Group>
				</Tab>
			</Tabs>
		</ModalWindow>
	);
};

export default LoadDataModal;
